<template>
  <div>
    <v-btn outlined color="primary" class="ml-1" @click="reloadTable">
      <i aria-hidden="true" class="v-icon notranslate material-icons theme--light">sync</i>
    </v-btn>
  </div>
</template>

<script>

export default {
  name: "TablePanel",
  methods: {
    reloadTable() {
      this.$emit('reloadTable');
    }
  }
}
</script>